(function () {
    'use strict';

    function registrationRouteConfig($stateProvider) {

        $stateProvider
            .state('register', {
                url: '/register',
                controller: 'registrationSelectorController',
                controllerAs: 'registrationSelectorCtrl',
                templateUrl: 'registration/templates/registrationSelector.html',
                resolve: {
                    registrationConfiguration: [
                        "registrationDataService", "$state", "$filter", function (registrationDataService, $state, $filter) {
                            return registrationDataService.getRegistrationOptions().then(
                                function (data) {
                                    if (data.Entities.length === 1) {
                                        var entityType = data.Entities[0].EntityType;
                                        var entityTypeUnderscores = $filter('camelCaseToUnderscores')(entityType);
                                        $state.go('registerEntity', { entityType: entityTypeUnderscores });
                                    }
                                    return data;
                                }
                            )
                        }
                    ]
                }
            })
            .state('homeregister', {
                url: '/',
                views: {
                    "register": {
                        controller: 'registerEntityHomePageController',
                        controllerAs: 'registerEntityHomePageCtrl',
                        templateUrl: 'registration/templates/homepageRegistration.html',
                        resolve: {
                            entityType: [
                                "registrationDataService", function (registrationDataService) {
                                    return registrationDataService.getRegistrationOptions().then(
                                        function (data) {
                                            return data.Entities[0].EntityType;
                                        }
                                    )
                                }
                            ],
                            sessionData: [
                                "sessionDataService", function (sessionDataService) {
                                    return sessionDataService.loadSession().then(function (data) {
                                        return data;
                                    });
                                }
                            ]
                        }
                    },
                    "demo": {
                        url: '/requestademo',
                        controller: 'requestDemoSmallController',
                        controllerAs: 'requestDemoCtrl',
                        templateUrl: 'registration/templates/requestDemoSmall.html'
                    }
                }
            })
            .state('registerEntity', {
                url: '/register/*entityType',
                controller: 'registerEntityController',
                controllerAs: 'registerEntityCtrl',
                templateUrl: 'registration/templates/registerEntity.html',
                resolve: {
                    showProgressHeader: [
                        "registrationDataService", function (registrationDataService) {
                            return registrationDataService.getRegistrationOptions().then(
                                function (data) {
                                    return (data.Entities.length > 1);
                                }
                            )
                        }
                    ]
                }
            })
            .state('requestdemo', {
                url: '/requestademo',
                controller: 'requestDemoController',
                controllerAs: 'requestDemoCtrl',
                templateUrl: 'registration/templates/requestDemo.html'
            });
    };

    registrationRouteConfig.$inject = ['$stateProvider'];

    angular.module('ecap.registration').config(registrationRouteConfig);
})();